<div class="wrapper position-relative" [ngClass]="customClass">
  <span class="icon icon-calendar"></span>
  <input type="text" class="form-control date-range-control" [attr.placeholder]="placeholder" [value]="model" [formControl]="control" readonly
    autocomplete="off">
  <span *ngIf="showPlaceHolder" class="datetime-placeholder ">
    Select date/time and click «Submit»
  </span>
  <span class="fas fa-chevron-down position-absolute"></span>
</div>
